// Copyright (c) 2017 Deere & Company

import './high-rental-days.scss';
import React, {PropTypes} from 'react';
import HighRentalDaysItem from './high-rental-days-item';

const HighRentalDays = props =>
    <div>
        <div className='high-rental-days'>
            <HighRentalDaysItem
                className={props.highRentalDaysCount > 0 ? 'download-icon' : ''}
                count={props.highRentalDaysCount}
                onExport={props.onExport}
                status='RENTAL_PINS'
            />
        </div>
    </div>;

HighRentalDays.displayName = 'HighRentalDays';
HighRentalDays.propTypes = {
    highRentalDaysCount: PropTypes.number.isRequired,
    onExport: PropTypes.func.isRequired
};

export default HighRentalDays;



// WEBPACK FOOTER //
// ./src/product/search/components/high-rental-days.js